"use strict";
exports.__esModule = true;
exports.Filter = void 0;
var Filter;
(function (Filter) {
    Filter["Category"] = "category";
    Filter["Localization"] = "region";
    Filter["Thematic"] = "thematic";
    Filter["DateRange"] = "dateRange";
    Filter["Classification"] = "classification";
    Filter["CommonThematic"] = "commonThematic";
    Filter["Expertise"] = "expertise";
    Filter["FinancialPublication"] = "financialPublication";
    Filter["MediaThematic"] = "mediaThematic";
    Filter["MediaType"] = "mediaType";
    Filter["Publication"] = "publication";
    Filter["Year"] = "year";
})(Filter = exports.Filter || (exports.Filter = {}));
//# sourceMappingURL=filter.js.map